exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-input-box[data-v-580d6d78] {\n  margin-top: 10px;\n}\n.select-input-box[data-v-580d6d78] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  font-size: 13px;\n  padding-bottom: 10px;\n  font-weight: bold;\n}\n.discount-type-static[data-v-580d6d78] {  \n  padding-left: 10px;\n  margin-top: 32px;\n  font-weight: bold;\n}\n.discount-type[data-v-580d6d78] {\n  padding-left: 10px;\n  margin-top: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-580d6d78","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/input/InputDiscount.vue
// module id = fEXi
// module chunks = 53